module.exports = __webpack_public_path__ + "img/histogram.dffe0ef1.svg";